import React from 'react';
import { getOffsetForElement } from '~/src/libs/getOffsetForElement';

const useElementsPosition = (makeBodyRelative = false, options = { topOffset: 0, leftOffset: 0, negativeLeftOffset: 0, elWidth: 0 }) => {
  const ref = React.useRef();
  const [portalsPosition, setPortalsPosition] = React.useState('');
  const [elementsPosition, setElementsPosition] = React.useState({});

  const setOverlayDimensions = () => {
    if (!makeBodyRelative) return;
    if (!document) return;
    const body = document.querySelector('body');
    body.classList.add('relative');
    const bodyBounds = body.getBoundingClientRect();
    setPortalsPosition(`height:${bodyBounds.height}px; width: 100%; position: absolute; top: 0; left: 0; z-index: 1000`);
  };

  const updateElementsPosition = (element, ...events) => {
    events.forEach((event) =>
      window.addEventListener(event, () => {
        const { top, left, containerWidth } = getOffsetForElement(element);
        if (left + options.leftOffset + options.elWidth >= containerWidth) {
          setElementsPosition({
            top: `${top + options.topOffset}px`,
            left: `${left + options.negativeLeftOffset}px`,
          });
        } else {
          setElementsPosition({
            top: `${top + options.topOffset}px`,
            left: `${left + options.leftOffset}px`,
          });
        }
      })
    );
  };

  React.useEffect(() => {
    window.addEventListener('load', () => setOverlayDimensions());
    return () => window.removeEventListener('load', () => setOverlayDimensions());
  }, []);

  React.useEffect(() => {
    if (!ref?.current) return;
    if (window) {
      window.addEventListener('resize', () => setOverlayDimensions());
      updateElementsPosition(ref.current, 'click', 'resize');
    }

    return () => {
      const body = document.querySelector('body');
      if (body) {
        body.classList.remove('relative');
      }
      window.addEventListener('resize', () => setOverlayDimensions());
    };
  }, [ref]);

  return [ref, portalsPosition, elementsPosition];
};

export default useElementsPosition;
